import { alpha } from '@mui/material/styles';
import { colorTokens, radiusTokens, typographyTokens } from '../app/designTokens';

const { semantic } = colorTokens;

/**
 * Canonical sidebar nav item styles (customer portal active state as source of truth).
 * Active: Ripe Cherry border + surfaceSelected fill + white text + cherry icon.
 * Hover: softer than active; subtle cherry-tinted border when inactive.
 */
export function sidebarNavItemSx({ compact = false, selected = false } = {}) {
  return {
    mb: compact ? 0.25 : 0.5,
    minHeight: selected ? 32 : 28,
    px: compact ? 1 : 1.5,
    justifyContent: compact ? 'center' : 'flex-start',
    borderRadius: `${radiusTokens.navItem}px`,
    boxSizing: 'border-box',
    bgcolor: selected ? semantic.bg.surfaceSelected : 'transparent',
    border: selected
      ? `1px solid ${semantic.status.brand.border}`
      : '1px solid transparent',
    color: selected ? semantic.text.primary : semantic.text.secondary,
    transition: 'background-color 120ms ease, border-color 120ms ease, color 120ms ease',
    '&:hover': {
      bgcolor: selected
        ? semantic.bg.surfaceSelected
        : semantic.action.secondary.bg,
      borderColor: selected
        ? semantic.status.brand.border
        : alpha(colorTokens.brand.primary, 0.35),
      color: semantic.text.primary,
      '& .MuiListItemIcon-root': {
        color: selected
          ? colorTokens.brand.primary
          : colorTokens.brand.primaryLight,
      },
    },
    '&.Mui-selected': {
      bgcolor: semantic.bg.surfaceSelected,
      color: semantic.text.primary,
      '&:hover': {
        bgcolor: semantic.bg.surfaceSelected,
      },
      '& .MuiListItemIcon-root': {
        color: colorTokens.brand.primary,
      },
    },
    '&:focus-visible': {
      outline: `2px solid ${semantic.status.brand.border}`,
      outlineOffset: 2,
    },
  };
}

export function sidebarNavIconSx({ compact = false, selected = false } = {}) {
  return {
    minWidth: compact ? 0 : 36,
    mr: compact ? 0 : 1,
    justifyContent: 'center',
    color: selected ? colorTokens.brand.primary : semantic.text.secondary,
  };
}

export function sidebarNavTextProps({ selected = false, fontSize = 13 } = {}) {
  return {
    fontFamily: typographyTokens.fontFamily,
    fontSize,
    fontWeight: selected
      ? typographyTokens.fontWeightSemibold
      : typographyTokens.fontWeightRegular,
    letterSpacing: '0.24px',
    color: selected ? semantic.text.primary : semantic.text.secondary,
  };
}
